import gsap from 'gsap';
import bodymovin from 'lottie-web';

const IS_MOBILE = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
const SCALE_HIDDEN = 0.6;
const ANIM_DURATION = 0.4;

class AtmosphereCard {
    constructor(data, index, translator) {
        this.data = data;
        this.index = index;
        this.translator = translator;
        this.element = document.createElement('div');
        this.element.classList.add('atmosphere-card', 'atmosphere-card-' + data.id);

        this.x = 0;
        this.y = 0;
        this.width = 0;
        this.height = 0;
        this.color = '';

        const imageContainerElem = document.createElement('div');
        imageContainerElem.classList.add('atmosphere-card-img-container');
        this.element.appendChild(imageContainerElem);

        this.animation = null;

        if (!IS_MOBILE && this.data.card && typeof this.data.card === 'string' && this.data.card.endsWith('.json')) {
            this.entered = false;
            this.animation = bodymovin.loadAnimation({
                container: imageContainerElem,
                path: this.data.card,
                renderer: 'canvas',
                loop: false,
                width: '100%',
                height: '100%',
                autoplay: false,
                rendererSettings: {
                    preserveAspectRatio: 'xMinYMin slice',
                    viewBoxOnly: true,
                    viewBoxSize: '0 0 334 517',
                }
            });
            this.element.addEventListener('mouseenter', () => {
                this.entered = true;
                if (this.animation.isPaused) {
                    this.animation.goToAndPlay(0);
                }
            });
            this.element.addEventListener('mouseleave', () => {
                this.entered = false;
            });
        } else if (!IS_MOBILE && this.data.card) {
            const imgElem = document.createElement('img');
            imgElem.src = this.data.card;
            imageContainerElem.appendChild(imgElem);
        } else if (this.data.cardImage) {
            const imgElem = document.createElement('img');
            imgElem.src = this.data.cardImage;
            imageContainerElem.appendChild(imgElem);
        }


        const titleSpan = document.createElement('span');
        titleSpan.classList.add('atmosphere-card-title');
        titleSpan.textContent = this.data.title in this.translator.dictionary ? this.translator.dictionary[this.data.title] : this.data.title;
        this.element.appendChild(titleSpan);

        gsap.set(this.element, { scaleX: SCALE_HIDDEN, autoAlpha: 0 });

        this.shown = false;
    }

    resize(x, y, width, height) {
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
        gsap.set(this.element, {
            x: this.x, y: this.y, width: this.width, height: this.height,
            scale: this.shown ? 1 : SCALE_HIDDEN, autoAlpha: this.shown ? 1 : 0
        });
    }

    select(color) {
        if (color && color.length) {
            this.color = color;
            this.element.style.boxShadow = `0px 0px 0px 8px ${color}`;
        }
        this.element.classList.add('selected');
    }

    unselect() {
        if (this.color && this.color.length) {
            this.element.style.boxShadow = `0px 0px 0px 0px ${this.color}`;
        }
        this.element.classList.remove('selected');
    }

    show(delay = 0) {
        this.shown = true;
        gsap.to(this.element, {
            duration: ANIM_DURATION, ease: 'back.out',
            x: this.x, y: this.y, width: this.width, height: this.height,
            scale: 1,
            delay: 0.2 + delay
        });
        gsap.to(this.element, {
            duration: ANIM_DURATION + 0.1, ease: 'linear',
            autoAlpha: 1,
            delay: 0.2 + delay
        });
    }

    hide(delay = 0, callback = null, callbackScope = null) {
        this.shown = false;
        gsap.to(this.element, {
            duration: Math.max(0.25, ANIM_DURATION - 0.1), ease: 'back.in',
            x: this.x, y: this.y, width: this.width, height: this.height,
            scale: SCALE_HIDDEN,
            delay: delay,
        });
        gsap.to(this.element, {
            duration: Math.max(0.25, ANIM_DURATION - 0.1), ease: 'linear',
            autoAlpha: 0,
            delay: delay,
            onComplete: callback,
            callbackScope: callbackScope
        });
    }
}

export { AtmosphereCard }